import request from '@/util/request';
import qs from 'qs';

export const getCarInList = (params, options) =>
  request.get('/api/v4ward/car/carIn/page', Object.assign({}, options, { params }));

export const getCarOutList = (params, options) =>
  request.get('/api/v4ward/car/carOut/page', Object.assign({}, options, { params }));

export const getMoneyStatistic = (params, options) =>
  request.get('/api/v4ward/car/carOut/statisticMoney', Object.assign({}, options, { params }));

export const getRemainList = (params, options) =>
  request.get('/api/v4ward/car/carRemain/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/car/CarInOut/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/car/CarInOut/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/car/CarInOut/submit', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/car/CarInOut/submit', params, options);

export const getParkSpaceNode = (params, options) =>
  request.get('/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0', params, options);

export const getCarInGroupByPlateNumber = (params, options) =>
  request.get('/api/v4ward/car/getCarInGroupByPlateNumber', Object.assign({}, options, { params }));

export const selectCarInByGroup = (params, options) =>
  request.get('/api/park/car/in/selectCarInByGroup', Object.assign({}, options, { params }));
